import DialogContext from 'components/explore/prospector/Dialog/context';
import React from 'react';

const withDialog = Component => props => {
    return (
        <DialogContext.Consumer>
            {showDialog => <Component {...props} showDialog={showDialog} />}
        </DialogContext.Consumer>
    );
};

export default withDialog;
